import { readCookie } from "./commonUtils";

export const trackEvent = (
  interaction: string,
  labels: Record<string, unknown>
) => {
  if (typeof window.yleAnalytics === "object" && interaction) {
    window.yleAnalytics.trackEvent(interaction, { labels });
  }
};

export const trackShareEvent = (
  interaction: string,
  labelsValues: { language?: string }
) => {
  if (typeof window.yleAnalytics === "object" && interaction) {
    window.yleAnalytics.trackEvent(interaction, {
      labels: { yle_ui_language: labelsValues.language || "fin" }
    });
  }
};

export const getConsent = (): { userconsent?: string; yleconsent?: string } => {
  const userconsent = readCookie("userconsent");
  const yleconsent = readCookie("yleconsent");

  if (userconsent) {
    // a new consent cookie
    return { userconsent };
  }
  if (yleconsent) {
    // Old version of the consent cookie
    return { yleconsent };
  }

  return {};
};

export const snowplowAnalyticsExists = (): boolean => {
  return !!window.yleSnowplow && !!window.yleSnowplowReady;
};

export const waitForSnowplowAnalyticsReady = async (): Promise<void> => {
  return snowplowAnalyticsExists() ? window.yleSnowplowReady : undefined;
};
